<template>
  <div class="container-fluid">
  
     
      <MenuComponent></MenuComponent>
     
  </div>
 
</template>

<script>
import logoutComponent from '@/components/logoutComponent.vue';
import MenuComponent from '@/components/menuComponent.vue';
import NavComponent from '@/components/navComponent.vue';
  export default{
    components:{
      logoutComponent,
      NavComponent,
      MenuComponent
    }
  }
</script>

<style scoped>
.container-fluid{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Faz a div ocupar 100% da altura da tela */
  width: 100vw;  /* Faz a div ocupar 100% da largura da tela */
  background-image: url('@/assets/login.webp');
  background-size: cover;        /* Faz a imagem cobrir toda a área */
  background-position: center;   /* Centraliza a imagem */
  background-repeat: no-repeat;
}

</style>